import { render, staticRenderFns } from "./newPartyBuilding.vue?vue&type=template&id=90a7d54c&scoped=true&"
import script from "./newPartyBuilding.vue?vue&type=script&lang=js&"
export * from "./newPartyBuilding.vue?vue&type=script&lang=js&"
import style0 from "./newPartyBuilding.vue?vue&type=style&index=0&lang=css&"
import style1 from "./newPartyBuilding.vue?vue&type=style&index=1&id=90a7d54c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90a7d54c",
  null
  
)

export default component.exports